'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('award-claim', {
    url: '/award/:clinicId/claim/:step/?username&email',
    templateUrl: '/views/award-claim.html',
    controller: 'AwardClaimCtrl',
    data: {
      wizardView: true,
    },
    resolve: {
      pageTitle: function($pageTitle) {
        $pageTitle.set('Claim Clinic Award - Opencare');
      },
      clinic: function($stateParams, ClinicService) {
        return ClinicService.getClinic($stateParams.clinicId);
      },
      award: function($stateParams, ClinicService) {
        return ClinicService.getClinicAward($stateParams.clinicId);
      },
      user: function(CurrentUser) {
        return CurrentUser.waitForUserLoad(CurrentUser.getUser);
      },
    },
  });
});

angular.module('ClinicApp').controller('AwardClaimCtrl', function($scope, $document, $q, $state, $stateParams, $location, clinic, award, user, OCWizardUtil, OCDomUtil, OCModalUtil, OCSocialUtil, OCStringUtil, ClinicConfig, WizardHandler, ClinicService, GrowlService) {
  $scope.clinic = clinic;
  $scope.clinic.address.street = $scope.clinic.address.street_number + ' ' + $scope.clinic.address.route;
  $scope.clinic.name = '';

  // Clinic primary specialty is required.
  if (!$scope.clinic.primarySpecialty) {
    GrowlService.error('Not enough data to claim award of the clinic.');
    return $state.go('home', null, {
      location: 'replace',
    });
  }

  var currentStep = parseInt($stateParams.step || 1, 10);
  var redirectStep = null;

  if ($scope.clinic.awardData) {
    if ($scope.clinic.awardData.claimedAt && $scope.clinic.awardData.verifiedAt && currentStep) {
      // If award is already claimed & verified redirect user to the award sharing step.
      redirectStep = 4;
    } else if ($scope.clinic.awardData.claimedAt && currentStep == 1) {
      // If award is already claimed redirect user to the digital award step.
      redirectStep = 3;
    }
  }

  if (redirectStep && redirectStep != currentStep) {
    return $state.go($state.current.name, {
      step: redirectStep,
    }, {
      location: 'replace',
    });
  }

  OCWizardUtil.setStep($scope, currentStep);

  if (currentStep == 4) {
    OCSocialUtil.addthisToolbox('#addthis-toolbox');
  }

  $scope.user = user;
  $scope.username = $scope.user.authenticated && $scope.user.firstName ? $scope.user.firstName : $stateParams.username;
  $scope.userEmail = $scope.user.authenticated ? $scope.user.email : $stateParams.email;
  $scope.websiteAdmin = {};
  $scope.codeSnippet = award.codeSnippet;
  $scope.awardGuide = {
    currentStep: 1,
  };

  $scope.$watch(function() {
    return WizardHandler.wizard();
  }, function() {
    // Disable appearing of the title tooltip that is added automatically by the wizard.
    $document.find('section.step').each(function() {
      this.title = '';
    });
  });

  $scope.nextStep = function() {
    var nextStep = currentStep + 1;
    $state.go($state.current.name, {
      step: nextStep,
    });
  };

  $scope.finish = function() {
    // Using $location instead of $state because it allow to use
    // proper `nextUrl` value when user is not authenticated.
    $location.path('/clinic/' + $scope.clinic.id + '/');
  };

  $scope.confirmAddress = function(form) {
    if (form.$invalid) {
      return $q.reject();
    }
    if ($scope.clinic.awardData && $scope.clinic.awardData.claimedAt) {
      $scope.nextStep();
      return $q.when();
    }
    return saveAddress().then(function() {
      // Mark clinic award as claimed.
      return ClinicService.claimAward($scope.clinic.id);
    })
      .then(function() {
        $scope.nextStep();
      });
  };

  $scope.selectWebsiteAdmin = function(type) {
    $scope.websiteAdmin.type = type;
  };

  $scope.emailWebsiteAdmin = function() {
    if (!$scope.websiteAdmin.email) {
      return $q.reject();
    }

    // Messages on behalf of yahoo.com could not be delivered due to domain policy restrictions.
    var sendFromClinicOwner = $scope.userEmail && !(/^.+@yahoo\.com$/i).test($scope.userEmail);

    return $q.when().then(function() {
      if (sendFromClinicOwner) {
        return OCModalUtil.showModal(
          'clinicAwardItEmail',
          {
            clinic: $scope.clinic,
            sender: {
              name: $scope.username,
              email: $scope.userEmail,
            },
            recepient: {
              email: $scope.websiteAdmin.email,
            },
            codeSnippet: $scope.codeSnippet,
          },
        );
      }
    })
      .then(function() {
        return saveItEmail($scope.websiteAdmin.email);
      })
      .then(function() {
        $scope.websiteAdmin.notified = true;
      });
  };

  $scope.nextGuideStep = function() {
    var step = $scope.awardGuide.currentStep + 1;
    $scope.awardGuide.currentStep = step;
  };

  $scope.emailCodeSnippetCopy = function() {
    if (!$scope.userEmail) {
      return GrowlService.error("Couldn't send a copy of your digital award.");
    }

    GrowlService.success('A copy of the digital award has been sent to your email ' + $scope.userEmail);
    $scope.nextStep();
  };

  $scope.openAwardVerification = function() {
    return OCModalUtil.showModal(
      'clinicAwardVerify',
      {
        clinic: $scope.clinic,
        user: getUser(),
        enableGuideOnFail: true,
      },
    ).then($scope.nextStep);
  };

  $scope.clinicCitySpecialtyUrl = function() {
    return ClinicConfig.SEARCH_APP_URL
      + '/' + $scope.clinic.primarySpecialty.slugPlural
      + '/' + OCStringUtil.slugify($scope.clinic.address.locality) + '-' + OCStringUtil.slugify($scope.clinic.address.administrative_area_level_1_short)
      + '/#tc' + $scope.clinic.id;
  };

  $scope.clinicSocialDescription = function(isTweet, noUrl) {
    var tmplRegular = '{{clinic_name}} was ranked as one of the top {{city}} {{specialty}} practices in {{year}}! {{url}}';
    var tmplTwitter = [
      'Named one of the top {{specialty}} practices in {{city}}! {{hashTag}} {{mentionTag}}',
      'We were ranked as one of the top {{city}} {{specialty}} practices in {{year}}! {{hashTag}} {{mentionTag}}',
      "{{clinic_name}} is one of {{year}}'s top {{specialty}} practices in {{city}}! {{hashTag}} {{mentionTag}}",
    ];

    var formatter = function(tmpl) {
      return tmpl.replace('{{clinic_name}}', $scope.clinic.name)
        .replace('{{city}}', $scope.clinic.address.locality)
        .replace('{{specialty}}', $scope.clinic.primarySpecialty.field.toLowerCase())
        .replace('{{year}}', new Date().getFullYear())
        .replace('{{url}}', noUrl ? '' : $scope.clinicCitySpecialtyUrl())
        .replace('{{hashTag}}', '#PatientsChoiceAwards')
        .replace('{{mentionTag}}', '@opencare');
    };

    var tmpl = tmplRegular;

    if (isTweet) {
      if ($scope.clinic.name && $scope.clinic.name.length > 20) {
        _.remove(tmplTwitter, function(_tmpl) {
          return _tmpl.indexOf('{{clinic_name}}') !== -1;
        });
      }
      tmpl = tmplTwitter[parseInt(Math.random() * tmplTwitter.length, 10)];
    }

    return formatter(tmpl);
  };

  function getUser() {
    if ($scope.user && $scope.user.authenticated) {
      return $scope.user;
    } else if ($scope.username && $scope.userEmail) {
      return {
        firstName: $scope.username,
        email: $scope.userEmail,
      };
    }
    return null;
  }

  // Saves mailing address to the specific Google Spreadsheet using iframe transport.
  function saveAddress() {
    var action = 'https://docs.google.com/forms/d/1oZvtxKBrt6O4VIGFTOwij4iTWfWgump9NlxJrCaCFSQ/formResponse';
    var data = {
      'entry.1436175283': $scope.clinic.name,
      'entry.1011505985': $scope.clinic.address.street,
      'entry.709107122': $scope.clinic.address.suite,
      'entry.328796999': $scope.clinic.address.locality,
      'entry.776965758': $scope.clinic.address.administrative_area_level_1,
      'entry.1804258861': $scope.clinic.address.postal_code,
      'entry.1387121884': $scope.clinic.primarySpecialty.namePlural,
      'entry.635254784': $scope.userEmail || '',
      'entry.1261698539': ClinicConfig.HOSTNAME,
    };

    return OCDomUtil.submitThroughIframe(action, 'POST', data);
  }

  function saveItEmail(itEmail) {
    var action = 'https://docs.google.com/forms/d/1enzs7B5C_BIOSeKLdZOrmd701yzf4FBwoGWMxTTM5Jo/formResponse';
    var data = {
      'entry.353094188': $scope.userEmail,
      'entry.961728375': $scope.username,
      'entry.146073402': $scope.clinic.name,
      'entry.410683125': $scope.clinic.address.locality,
      'entry.1117515201': $scope.clinic.primarySpecialty.namePlural,
      'entry.1289604827': itEmail,
      'entry.456553477': ClinicConfig.HOSTNAME,
    };

    return OCDomUtil.submitThroughIframe(action, 'POST', data);
  }
});
